module.exports = __webpack_public_path__ + "media/question1_au.0af2d3a7.mp3";